import { Temporal } from '@js-temporal/polyfill'
import { Decimal } from 'decimal.js'
import rfdc from 'rfdc'

function isDecimalPlainObject (value: object): value is { s: number; e: number; d: number[] } {
  return 'd' in value && 'e' in value && 's' in value && Array.isArray((value as { d: unknown }).d)
}

function cloneDecimal (value: unknown): Decimal {
  if (value instanceof Decimal) {
    return new Decimal(value.toNumber())
  }
  if (typeof value === 'object' && value !== null && typeof (value as Decimal).toDecimalPlaces === 'function') {
    return new Decimal((value as Decimal).toNumber())
  }
  if (typeof value === 'object' && value !== null && isDecimalPlainObject(value)) {
    const sign = value.s < 0 ? '-' : ''
    const digits = value.d.join('')
    const exponent = value.e - digits.length + 1
    return exponent === 0 ? new Decimal(`${sign}${digits}`) : new Decimal(`${sign}${digits}e${exponent}`)
  }
  return new Decimal(value as Decimal.Value)
}

const clone = rfdc({
  constructorHandlers: [
    [Decimal, cloneDecimal],
    [Temporal.Instant, Temporal.Instant.from],
    [Temporal.ZonedDateTime, Temporal.ZonedDateTime.from],
    [Temporal.PlainDate, Temporal.PlainDate.from],
    [Temporal.PlainTime, Temporal.PlainTime.from],
    [Temporal.PlainDateTime, Temporal.PlainDateTime.from],
    [Temporal.PlainMonthDay, Temporal.PlainMonthDay.from],
    [Temporal.Duration, Temporal.Duration.from]
  ]
})

export function useObjectClone<T> (obj: T): T {
  return clone(obj)
}
